import { DOWNLOAD_PLATFORMS } from '../../utils/helpers/games/downloadPlatforms';
import styles from './DownloadSection.module.css';

export default function DownloadSection({ t }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.cards}>
        {DOWNLOAD_PLATFORMS.map((store, i) => {
          const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(store.link)}`;

          return (
            <div key={i} className={styles.card}>
              <div className={styles.qrBox}>
                <img src={qrUrl} alt="QR code" className={styles.qrImage} />
                <span className={styles.scanText}>{t("scan_to_download")}</span>
              </div>
              <a href={store.link} target="_blank" rel="noreferrer">
                <img src={store.btnIcon} alt="" height={50} width={160} />
              </a>
            </div>
          );
        })}
      </div>
      <div className={styles.banner}>
        <div className={styles.bannerIcon}>
          <img src="/assets/intro/badge.svg" alt="" height={20} width={20} />
        </div>
        <div className={styles.bannerText}>
          <span className={styles.bannerTitle}>{t("safe_sound_for_explorers")}</span>
          <span className={styles.bannerSub}>{t("no_ads_no_tracking_just_play")}</span>
        </div>
      </div>
    </div>
  );
}